/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_SourceInputs */

const en_wc_footer_source = /** @type {(inputs: Wc_Footer_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source code (GitHub)`)
};

/**
* | output |
* | --- |
* | "Source code (GitHub)" |
*
* @param {Wc_Footer_SourceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_source = /** @type {((inputs?: Wc_Footer_SourceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_SourceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_source(inputs)
});
export { wc_footer_source as "wc.footer.source" }